import "../../../resources/less/Family/ThemePages/Manga.less";
import BaseThematique from "./BaseThematique";

class Manga extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new Manga();
});
